module.exports = __webpack_public_path__ + "img/trial2-1.ba5d7c29.png";